import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgSelectConfig, NgSelectModule } from '@ng-select/ng-select';
import { AuthGuard } from '../auth/guards/auth.guard';
import { CoreModule } from '../core/core.module';
import { DeliveryNotesComponent } from './pages/delivery-notes/delivery-notes.component';
import { DeliveryNoteEditComponent } from './pages/delivery-note-edit/delivery-note-edit.component';
import { PickingSlipsComponent } from './pages/picking-slips/picking-slips.component';
import { PickingSlipComponent } from './pages/picking-slip/picking-slip.component';

const routes: Routes = [
  { path: 'delivery-notes', component: DeliveryNotesComponent, canActivate: [AuthGuard] },
  { path: 'delivery-notes/new', component: DeliveryNoteEditComponent, canActivate: [AuthGuard] },
  { path: 'delivery-notes/edit/:id', component: DeliveryNoteEditComponent, canActivate: [AuthGuard] },
  { path: 'picking-slips', component: PickingSlipsComponent, canActivate: [AuthGuard] },
  { path: 'picking-slips/:id', component: PickingSlipComponent, canActivate: [AuthGuard] },
];

/** Delivery notes and picking slips (docs/superpowers/specs/2026-10-22-delivery-notes-picking-design.md). */
@NgModule({
  declarations: [DeliveryNotesComponent, DeliveryNoteEditComponent, PickingSlipsComponent, PickingSlipComponent],
  imports: [CommonModule, FormsModule, CoreModule, NgSelectModule, RouterModule.forChild(routes)],
  providers: [NgSelectConfig],
})
export class DeliveryNotesModule { }
